import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const Offer = () => {

    useEffect(() => {
        AOS.init({
            duration: 1500,
            once: true,
            disable: function () {
                return window.innerWidth < 992;
            },
        });
    }, []);

    return (
        <section className="wi_full py_3 what_offer_sec">
            <div className="container">
                <div className="sec_title text-center" data-aos="fade-up">
                    <h2>What we <span>offer</span></h2>
                </div>
                {/* <div className="row mt-3">
                    <div className="col-lg-4 col_item" data-aos="fade-right">
                        <div className="item_inner">
                            <span className="item_icon">
                                <img src="./images/offer-icon-1.svg" alt="Icon" />
                            </span>
                            <h3>Individual & Family Health Insurance (IHC)</h3>
                            <p>We help self-employed workers, early retirees, students, and individuals without employer coverage find affordable health plans that meet their needs.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col_item" data-aos="fade-right">
                        <div className="item_inner">
                            <span className="item_icon">
                                <img src="./images/offer-icon-2.svg" alt="Icon" />
                            </span>
                            <h3>Medicare Plans Made Simple</h3>
                            <p>Turning 65? We simplify your Medicare options — including Advantage Plans, Medigap, and Part D drug coverage — with personalized advice and trusted support.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col_item" data-aos="fade-right">
                        <div className="item_inner">
                            <span className="item_icon">
                                <img src="./images/offer-icon-3.svg" alt="Icon" />
                            </span>
                            <h3>Short-Term, Vision, Dental & More</h3>
                            <p>Need coverage while between jobs or waiting for open enrollment? We offer flexible short-term health plans and affordable add-ons like dental and vision.</p>
                        </div>
                    </div>
                </div> */}
                <ul className="nav nav-tabs justify-content-center" id="myTab" role="tablist" data-aos="fade-up">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">under 65</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">over 65</button>
                    </li>
                </ul>
                <div className="tab-content mt-3" id="myTabContent">
                    <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                        <div className="row">
                            <div className="col-lg-4 col_item" data-aos="fade-right">
                                <div className="item_inner">
                                    <span className="item_icon">
                                        <img src="./images/offer-icon-1.svg" alt="Icon" />
                                    </span>
                                    <h3>Individual & Family</h3>
                                    <p>
                                        Health coverage designed to protect you and your loved ones, with options that fit both your care needs and your budget.
                                        <br />
                                        <strong>Bronze, Silver & Gold Plans: </strong>
                                        Choose the level of coverage that works best for you.
                                        <br />

                                        <strong>Affordable Options: </strong>
                                        From budget-friendly plans to more comprehensive coverage.
                                        <br />

                                        <strong>Smarter Savings: </strong>
                                        Reduce out-of-pocket costs while maximizing the value of your health insurance.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col_item" data-aos="fade-right">
                                <div className="item_inner">
                                    <span className="item_icon">
                                        <img src="./images/offer-icon-2.svg" alt="Icon" />
                                    </span>
                                    <h3>Ancillary</h3>
                                    <p>
                                        Extra protection that works alongside your main health insurance to cover important everyday needs.
                                        <br />
                                        <strong>Dental & Vision: </strong>
                                        Preventive care, routine check-ups, treatments, glasses, and contacts.
                                        <br />
                                        <strong>Comprehensive Coverage: </strong>
                                        Options for life, disability, and accident insurance.
                                        <br />
                                        <strong>Flexible Choices: </strong>
                                        Plans designed to fit a wide range of needs and budgets.
                                        <br />
                                        <strong>Trusted Providers: </strong>
                                        Access to broad networks of dentists, vision specialists, and more.
                                    </p>

                                </div>
                            </div>
                            <div className="col-lg-4 col_item" data-aos="fade-right">
                                <div className="item_inner">
                                    <span className="item_icon">
                                        <img src="./images/offer-icon-3.svg" alt="Icon" />
                                    </span>
                                    <h3>Small & Mid-Size Business</h3>
                                    <p>
                                        Flexible health coverage options designed to help businesses care for their teams while managing costs.
                                        <br />
                                        <strong>Traditional Small Group: </strong>
                                        Comprehensive group insurance tailored to employers and employees.
                                        <br />
                                        <strong>SHOP (Small Business Health Options Program): </strong>
                                        Affordable plans with potential tax credits to lower premium costs.
                                        <br />
                                        <strong>ICHRA (Individual Coverage HRA): </strong>
                                        A modern, flexible approach—reimburse employees for individual health premiums and medical expenses.
                                        <br />
                                        <strong>Scalable Solutions: </strong>
                                        Options that grow with your business, from small teams to mid-sized companies.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                        <div className="row">
                            <div className="col-md-4 col_item">
                                <div className="item_inner">
                                    <span className="item_icon">
                                        <img src="./images/offer-icon-1.svg" alt="Icon" />
                                    </span>
                                    <h3>Medicare Advantage (Part C)</h3>
                                    <p>
                                        All-in-one plans that combine your Medicare benefits with extra coverage.
                                        <br />
                                        <strong>Bundled Benefits: </strong>
                                        Includes hospital (Part A), medical (Part B), and often prescription drugs (Part D).
                                        <br />
                                        <strong>Extra Coverage: </strong>
                                        Many plans offer dental, vision, hearing, and wellness benefits.
                                        <br />
                                        <strong>Convenience: </strong>
                                        One plan, one card, and one network for your care.
                                        <br />
                                        <strong>Which option is right for me? </strong>
                                        Choose Medicare Advantage if you want a simple, all-in-one plan with extra benefits and are comfortable using a provider network.
                                    </p>

                                </div>
                            </div>
                            <div className="col-md-4 col_item">
                                <div className="item_inner">
                                    <span className="item_icon">
                                        <img src="./images/offer-icon-2.svg" alt="Icon" />
                                    </span>
                                    <h3>Medicare Supplement (Medigap)</h3>
                                    <p>
                                        Plans designed to fill the gaps in Original Medicare and lower your out-of-pocket costs.
                                        <br />
                                        <strong>Cost Protection: </strong>
                                        Helps pay deductibles, copayments, and coinsurance.
                                        <br />
                                        <strong>Flexibility: </strong>
                                        Choose any doctor or hospital that accepts Medicare.
                                        <br />
                                        <strong>Peace of Mind: </strong>
                                        Predictable costs and fewer surprises with your healthcare expenses.
                                        <br />
                                        <strong>Which option is right for me? </strong>
                                        Choose Medigap if you want maximum freedom to see any Medicare provider and prefer more predictable healthcare costs.
                                    </p>

                                </div>
                            </div>
                            <div className="col-md-4 col_item">
                                <div className="item_inner">
                                    <span className="item_icon">
                                        <img src="./images/offer-icon-3.svg" alt="Icon" />
                                    </span>
                                    <h3>Prescription Drug Coverage (Part D)</h3>
                                    <p>
                                        Standalone coverage that helps pay for the cost of medications.
                                        <br />
                                        <strong>Affordable Options: </strong>
                                        Wide range of plans to fit your prescription needs and budget.
                                        <br />
                                        <strong>Pharmacy Access: </strong>
                                        Coverage at thousands of participating pharmacies nationwide.
                                        <br />
                                        <strong>Smart Savings: </strong>
                                        Helps lower drug costs and protects against high out-of-pocket expenses.
                                        <br />
                                        <strong>Which option is right for me? </strong>
                                        Choose Part D if you need prescription coverage to go with Original Medicare or a Medigap plan.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}